import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import {NachrichtenService} from "../services/apiservices/nachrichten.service";
import {OrdnerEnum} from "../model/ordner.enum";

// Kernfunktion, die auf Basis eines Ordners und des Route-Snapshots lädt
function resolveNachricht(ordner: OrdnerEnum, route: ActivatedRouteSnapshot) {
    const nachrichtId = route.paramMap.get('nachrichtId');
    return inject(NachrichtenService).getNachricht(ordner, nachrichtId);
}


// 1) Allgemeiner Resolver: liest ordner-Param oder nimmt ERHALTEN als Default
export const nachrichtenResolver: ResolveFn<any> = (route) => {
    const ordnerParam = route.paramMap.get('ordner');
    const ordner =
        Object.values(OrdnerEnum).includes(ordnerParam as OrdnerEnum)
            ? (ordnerParam as OrdnerEnum)
            : OrdnerEnum.ERHALTEN;
    return resolveNachricht(ordner, route);
};



// 2) Spezieller Resolver für Entwürfe: ignoriert param, nimmt ENTWURF
export const entwurfResolver: ResolveFn<any> = (route) => {
    return resolveNachricht(OrdnerEnum.ENTWURF, route);
};
